import type { ImpiantoDTO, NuovoImpiantoDTO } from '@/models/dto/impianto/impianto-dto'
import type { Facility, NewFacility } from '@/models/types/facility/facility'
import type { IfcElementData } from 'react-ifc-viewer'
import { mapToFacilityStatus, mapToStatoImpianto } from './facility-status-mapper'

const mapToFacility = (impiantiDTO: ImpiantoDTO): Facility => {
    return { ...mapToNewFacility(impiantiDTO), id: impiantiDTO.id }
}

const mapToImpiantoDTO = (facility: Facility): ImpiantoDTO => {
    return { ...mapToNuovoImpiantoDTO(facility), id: facility.id }
}

const mapToNewFacility = (impiantiDTO: NuovoImpiantoDTO): NewFacility => {
    let ifcConfigurationData: IfcElementData[] | undefined
    try {
        ifcConfigurationData = impiantiDTO.ifcMetadata ? (JSON.parse(impiantiDTO.ifcMetadata) as IfcElementData[]) : []
    } catch {
        // logger.error('Errore nel parsing dei metadata ifc:')
        // logger.log(ifcConfigurationData)
    }

    return {
        name: impiantiDTO.nome ?? undefined,
        address: impiantiDTO.indirizzo ?? undefined,
        city: impiantiDTO.città ?? undefined,
        province: impiantiDTO.provincia ?? undefined,
        postalCode: impiantiDTO.cap ?? undefined,
        latitude: impiantiDTO.latitudine ?? undefined,
        longitude: impiantiDTO.longitudine ?? undefined,
        enabled: impiantiDTO.attivo ?? undefined,
        description: impiantiDTO.descrizione ?? undefined,
        status: mapToFacilityStatus(impiantiDTO.statoImpianto),
        blueprintPath: impiantiDTO.file2DStoragePath,
        blueprintUrl: impiantiDTO.file2DUrl,
        iconPath: impiantiDTO.iconStoragePath,
        iconUrl: impiantiDTO.iconUrl,
        model3dPath: impiantiDTO.bimBlobStoragePath,
        model3dUrl: impiantiDTO.bimUrl,
        plcIds: impiantiDTO.idPlc ?? undefined,
        photovoltaicIds: impiantiDTO.idFotovoltaico ?? undefined,
        notificationEmail: impiantiDTO.mailNotifica ?? undefined,
        ifcConfigurationRawData: impiantiDTO.ifcMetadata ?? undefined,
        ifcConfigurationData,
    }
}

const mapToNuovoImpiantoDTO = (facility: NewFacility): NuovoImpiantoDTO => {
    return {
        nome: facility.name,
        indirizzo: facility.address,
        città: facility.city,
        provincia: facility.province,
        cap: facility.postalCode,
        latitudine: facility.latitude,
        longitudine: facility.longitude,
        attivo: facility.enabled,
        descrizione: facility.description,
        statoImpianto: mapToStatoImpianto(facility.status),
        iconUrl: facility.iconUrl,
        iconStoragePath: facility.iconPath,
        file2DUrl: facility.blueprintUrl,
        file2DStoragePath: facility.blueprintPath,
        bimUrl: facility.model3dUrl,
        bimBlobStoragePath: facility.model3dPath,
        idPlc: facility.plcIds ?? null,
        idFotovoltaico: facility.photovoltaicIds ?? null,
        mailNotifica: facility.notificationEmail ?? null,
        ifcMetadata: facility.ifcConfigurationRawData ?? null,
    }
}

export { mapToFacility, mapToImpiantoDTO, mapToNewFacility, mapToNuovoImpiantoDTO }
